import dayjs from 'dayjs';

export default {
  // ======================= COMMON =========================
  GET_APP_MENU(state) {
    return state.appMenu;
  },
  GET_APPL_YMD(state) {
    return state.applYmd;
  },
  GET_REQUEST_HOUR(state) {
    return state.requestHour;
  },
  GET_HOL_OT_HOUR(state) {
    return state.holOtHour;
  },
  GET_BASIC_HOUR(state) {
    return state.hour;
  },
  // 시작시간
  GET_REQ_S_HM(state) {
    return state.reqSHm !== ''
      ? `${state.reqSHm.substr(0, 2)}:${state.reqSHm.substr(2, 2)}`
      : '';
  },
  // 종료시간
  GET_REQ_E_HM(state) {
    return state.reqEHm !== ''
      ? `${state.reqEHm.substr(0, 2)}:${state.reqEHm.substr(2, 2)}`
      : '';
  },
  // 시작시간 ~ 종료시간
  GET_REQ_S_E_HM(state) {
    if (state.reqSHm !== '' && state.reqEHm !== '') {
      return `${state.reqSHm.substr(0, 2)}:${state.reqSHm.substr(2, 2)} 
      ~ ${state.reqEHm.substr(0, 2)}:${state.reqEHm.substr(2, 2)}`;
    } else {
      return '';
    }
  },
  //2025.03.12 연장근무신청 연장근무정보 직접입력 기능 추가
  GET_OT_INFO_DIRECT_YN(state) {
    return state.otInfoDirectYn;
  },
  GET_DIRECT_REQUEST_HOUR(state) {
    return state.directRequestHour;
  },
  GET_DIRECT_REST_HOUR(state) {
    return state.directRestHour;
  },
  GET_REASON_FLAG(state) {
    return state.reasonFlag;
  },
  GET_REASON(state) {
    return state.reason;
  },

  // ======================= PLAN =======================
  GET_PLAN_PARAM(state) {
    return state.planParam;
  },
  // ======================= ATTEND =======================
  GET_ATTEND_PARAM(state, getters) {
    const attendParam = state.attendParam;
    return {
      ...attendParam,
      ...getters.GET_ELA_APPL_PARAM,
    };
  },
  GET_BEFORE_START_HM(state) {
    if (state.bfShm !== '') {
      return `${state.bfShm.substr(0, 2)}:${state.bfShm.substr(2, 2)}`;
    } else {
      return '';
    }
  },
  GET_BEFORE_END_HM(state) {
    if (state.bfEhm !== '') {
      return `${state.bfEhm.substr(0, 2)}:${state.bfEhm.substr(2, 2)}`;
    } else {
      return '';
    }
  },

  // ======================= REWARD =======================
  GET_REWARD_PARAM(state, getters) {
    const rewardParam = state.rewardParam;
    return {
      ...rewardParam,
      ...getters.GET_ELA_APPL_PARAM,
    };
  },
  GET_REWARD_LIST(state) {
    return state.rewardList;
  },
  GET_USE_REWARD_LIST(state) {
    return state.useRewardList;
  },
  GET_REWARD_TOTAL_REST_TIME(state) {
    let restTime = 0;
    state.rewardList.forEach(reward => {
      console.log(reward);
      restTime += reward.restTime;
    });
    return restTime;
  },
  // 보상휴가 신청 메뉴 데이터
  GET_REWARD_APPL_MENU() {
    return { applCd: '42', gntGubunCd: '10', gubun: 'works' };
  },
  // ======================= SCHEDULE =======================
  GET_SCHEDULE_PARAM(state, getters) {
    const scheduleParam = state.scheduleParam;
    return {
      ...scheduleParam,
      ...getters.GET_ELA_APPL_PARAM,
    };
  },
  GET_STD_YMD(state) {
    return state.stdYmd ? dayjs(state.stdYmd).format('YYYY-MM-DD') : '';
  },
  GET_WORK_ORG_NM(state) {
    return state.workOrgNm;
  },
  GET_WORK_ORG_TIME_LIST(state) {
    return state.workOrgTimeList;
  },
  GET_SCHEDULE_TIME_CD(state) {
    return state.scheduleTimeCd;
  },
  GET_SCHEDULE_TIME_NM(state) {
    return state.scheduleTimeNm;
  },
  // ======================= OTWORK =========================
  GET_OTWORK_PARAM(state, getters) {
    const otworkParam = state.otworkParam;
    return {
      ...otworkParam,
      ...getters.GET_ELA_APPL_PARAM,
    };
  },
  GET_OTWORK_APPL_GUBUN(state) {
    return state.applGubun;
  },
  GET_HOL_YN(state) {
    return state.holYn;
  },
  GET_REQ_TIME_CD(state) {
    return state.reqTimeCd; // 휴일근무 보상구분
  },
  GET_ALTVAC_APPL_STATUS(state) {
    return state.altvacApplStatus;
  },
  GET_ALTER_YMD(state) {
    return state.alterYmd ? dayjs(state.alterYmd).format('YYYY-MM-DD') : '';
  },
  GET_ALTER_GNT_NM(state) {
    return state.alterGntNm;
  },
  GET_IN_OUT_YN(state) {
    return state.inoutYn;
  },
  GET_WORK_YMD(state) {
    return state.workYmd ? dayjs(state.workYmd).format('YYYY-MM-DD') : '';
  },
  GET_REST_HOUR(state) {
    return state.restHour;
  },

  // ======================= VACATION =======================

  GET_VACATION_PARAM(state, getters) {
    const vacationParam = state.vacationParam;
    return {
      ...vacationParam,
      ...getters.GET_ELA_APPL_PARAM,
    };
  },
  GET_ALTER_VACATION(state) {
    return state.alterVacation;
  },
  GET_GNT_GUBUN_CD(state) {
    return state.gntGubunCd;
  },
  GET_GNT_CD(state) {
    return state.gntCd;
  },
  GET_HOL_DAY(state) {
    return state.holDay;
  },
  GET_CLOSE_DAY(state) {
    return state.closeDay;
  },
  GET_REST_CNT(state) {
    return state.restCnt;
  },
  GET_S_YMD(state) {
    return state.sYmd !== '' ? dayjs(state.sYmd).format('YYYY-MM-DD') : '';
  },
  GET_E_YMD(state) {
    return state.eYmd !== '' ? dayjs(state.eYmd).format('YYYY-MM-DD') : '';
  },
  GET_HOL_WORK_YMD(state) {
    return state.holWorkYmd;
  },
  GET_GNT_FILE_ESS_YN(state) {
    return state.gntFileEssYn;
  },
  // 기간
  GET_S_E_YMD(state) {
    const reqUseType = state.gntCd.requestUseType;
    const sYmd = dayjs(state.sYmd).format('YYYY-MM-DD');
    const eYmd = dayjs(state.eYmd).format('YYYY-MM-DD');

    if (
      reqUseType === 'AM' ||
      reqUseType === 'PM' ||
      reqUseType === 'QT1' ||
      reqUseType === 'QT4' ||
      reqUseType === 'H' ||
      reqUseType === 'TQ1' ||
      reqUseType === 'TQ2'
    ) {
      return `${sYmd}`;
    } else {
      return `${sYmd} ~ ${eYmd}`;
    }
  },
  GET_DATE_TYPE(state) {
    const reqUseType = state.gntCd.requestUseType;
    if (
      reqUseType === 'AM' ||
      reqUseType === 'PM' ||
      reqUseType === 'QT1' ||
      reqUseType === 'QT4' ||
      reqUseType === 'TQ1' ||
      reqUseType === 'TQ2'
    ) {
      return 'OD'; // one day
    } else if (reqUseType === 'H') {
      return 'H'; // hour
    } else {
      return 'D'; // days
    }
  },

  // ======================= BIZTRIP =======================
  GET_BIZ_TRIP_COLS(state) {
    return state.bizTripCols;
  },
  GET_BIZ_TRIP_DATA(state) {
    return state.bizTripData;
  },
  GET_BIZ_TRIP_JOINER(state) {
    return state.bizTripJoiner;
  },
  GET_BIZ_TRIP_TITLE(state) {
    return state.bizTripTitle;
  },
  GET_BIZ_TRIP_SABUN_NOTE(state) {
    return state.bizTripSabunNote;
  },
  GET_BIZ_TRIP_DYNAMIC_COLS(state) {
    return state.bizTripDynamicCols;
  },

  // 출장기간
  GET_BIZ_TRIP_PERIOD(state) {
    const sYmd = dayjs(state.sYmd).format('YYYY-MM-DD');
    const eYmd = dayjs(state.eYmd).format('YYYY-MM-DD');

    // 요일 추출
    const sDay = dayjs(state.sYmd).format('ddd');
    const eDay = dayjs(state.eYmd).format('ddd');

    return `${sYmd}(${sDay})~${eYmd}(${eDay})`;
  },

  // 출장구분명
  GET_BIZ_TRIP_GNT_NM(state) {
    return state.bizTripGntNm;
  },

  // ======================= CERTI =======================
  GET_CERTI_PARAM(state, getters) {
    const certiParam = state.certiParam;
    return {
      ...certiParam,
      ...getters.GET_ELA_APPL_PARAM,
    };
  },
  GET_PURPOSE(state) {
    return state.purpose;
  },
  GET_SUBMIT_OFFICE(state) {
    return state.submitOffice;
  },
  GET_ADDRESS(state) {
    return state.address;
  },
  GET_ADDR_YN(state) {
    return state.addrYn;
  },
  GET_RES_NO_YN(state) {
    return state.resNoYn;
  },
  GET_GEMP_YN(state) {
    return state.gempYn;
  },
  GET_NOTE_YN(state) {
    return state.noteYn;
  },
  GET_PERIOD_YY_CNT(state) {
    return state.periodYyCnt;
  },
  GET_PERIOD_MM_CNT(state) {
    return state.periodMmCnt;
  },
  GET_PURPOSE_CD_LIST(state) {
    return state.purposeCdList;
  },

  // ======================= CANCEL =========================
  GET_CANCEL_PARAM(state, getters) {
    return {
      searchBfApplSeq: state.searchBfApplSeq,
      reason: state.reason,
      ...getters.GET_ELA_APPL_PARAM,
    };
  },
};
